import React from 'react';
import ModalSituacao from '../components/ModalSituacao';
import ModalVivenciado from '../components/ModalVivenciado';
import { Modal } from '../components/Modal';

const CtaButtons = (props) => {
   return(
      <React.Fragment>
         <Modal type="denuncie" modalContent={ModalSituacao()} />
         <Modal type="vivenciadas" modalContent={ModalVivenciado()} />
      </React.Fragment>
   )
}

export default CtaButtons;
